import { z } from "zod";
import { adminCountSchema, adminHealthSchema } from "./common.js";
/** What Crux stands on, and how close each piece is to its limit. */
export const adminServicesSchema = z.object({
    services: z.array(z.object({
        id: z.string(),
        label: z.string(),
        state: adminHealthSchema,
        headline: z.string(),
        detail: z.string(),
        checkedAt: z.string(),
        usage: z
            .object({ used: adminCountSchema, limit: adminCountSchema, unit: z.string() })
            .nullable(),
        /** Twenty-four hourly counts of what went wrong, oldest first. */
        problems: z.array(adminCountSchema),
    })),
});
//# sourceMappingURL=services.js.map